import {lazy} from 'react'

// components

export const ScienceArticlePage = lazy(
  () => import('./../../../../units/science/components/article-page'),
)

export const ScienceArticleReadingAssignmentSessionReportHandler = lazy(
  () => import('./../../../../units/science/components/reading-assignment-session-report'),
)

export const ScienceAssignArticlePage = lazy(
  () => import('./../../../../units/science/components/assign-article-page'),
)

export const ScienceAssignmentsHandler = lazy(
  () => import('./../../../../units/science/common/components/assignments'),
)

export const ScienceListingPageContainer = lazy(
  () => import('./../../../../units/science/components/listing-page'),
)

export const ScienceSearchOrListingPage = lazy(
  () => import('./../../../../units/science/components/search-or-listing'),
)

export const ScienceUnitPageHandler = lazy(
  () => import('./../../../../units/science/components/unit-page'),
)

export const ScienceWritingAssignmentReportHandler = lazy(
  () => import('./../../../../units/science/components/writing-assignment-session-report'),
)

export const ScienceReportsOverviewHandler = lazy(
  () => import('./../../../../units/science/components/science-reports-overview'),
)
